import { useTranslation } from 'react-i18next'
import PlentyBody from '#app/components/typography/plenty-body'
import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTrigger,
} from '#app/components/ui/dialog'
import { sizeGuidesURL } from '#app/features/pdp'
import useAmplitudeContext from '#app/hooks/use-amplitude-context'

const SizeGuideDialog = ({ brandKey }: { brandKey: string }) => {
	let { t } = useTranslation('product_details_page')
	const { trackAmplitudeEvent } = useAmplitudeContext()
	return (
		<Dialog>
			<div className="flex flex-col">
				<DialogTrigger
					className="group flex cursor-pointer flex-col hover:bg-transparent"
					onClickCapture={() => trackAmplitudeEvent('size guide clicked')}
				>
					<PlentyBody size="md">{t('size_guide')}</PlentyBody>
					<div className="flex w-full flex-row justify-center">
						<div className="bg-mint-green-80p h-[4px] w-0 rotate-0 rounded-sm transition-all group-hover:w-[4px] group-focus:w-full before:w-0"></div>
					</div>
				</DialogTrigger>
			</div>
			<DialogContent className="max-w-2xl">
				<DialogHeader className="pt-4">
					<iframe
						title="size-guide"
						className="min-h-[80vh] w-full"
						src={`${sizeGuidesURL}/${brandKey
							.toLowerCase()
							.replace(/[^a-zA-Z0-9&]/g, '')}.pdf`}
					/>
				</DialogHeader>
			</DialogContent>
		</Dialog>
	)
}

export default SizeGuideDialog
